import React, { createContext, useContext, useState } from 'react';
import CustomModal from '../components/CommonComponent/CustomModal/CustomModal';

const ModalStackContext = createContext();

export const useModalStack = () => {
  const context = useContext(ModalStackContext);
  if (!context) {
    throw new Error('useModalStack must be used within ModalStackProvider');
  }
  return context;
};

export const ModalStackProvider = ({ children }) => {
  const [modalStack, setModalStack] = useState([]);

  const pushModal = (modalConfig) => {
    setModalStack(prev => [...prev, { ...modalConfig, id: Date.now() }]);
  };

  const popModal = () => {
    setModalStack(prev => prev.slice(0, -1));
  };

  const clearStack = () => {
    setModalStack([]);
  };

  const replaceModal = (modalConfig) => {
    setModalStack([{ ...modalConfig, id: Date.now() }]);
  };

  return (
    <ModalStackContext.Provider value={{ pushModal, popModal, clearStack, replaceModal }}>
      {children}
      {modalStack.length > 0 && (
        <CustomModal
          key={modalStack[modalStack.length - 1].id}
          isOpen={true}
          onClose={() => {
            const topModal = modalStack[modalStack.length - 1];
            if (topModal.onClose) {
              topModal.onClose();
            }
            popModal();
          }}
          width={modalStack[modalStack.length - 1].width || '797px'}
          header={modalStack[modalStack.length - 1].header}
          footer={modalStack[modalStack.length - 1].footer}
          height={modalStack[modalStack.length - 1].height || ''}
          maxWidth={modalStack[modalStack.length - 1].maxWidth || '100vw'}
          maxHeight={modalStack[modalStack.length - 1].maxHeight || '100vh'}
          containerClass={modalStack[modalStack.length - 1].containerClass || ''}
          headerPosition={modalStack[modalStack.length - 1].headerPosition || 'start'}
          gap={modalStack[modalStack.length - 1].gap || 'gap-2xl'}
          isLeftAligned={modalStack[modalStack.length - 1].isLeftAligned || false}
          headerButton={modalStack[modalStack.length - 1].headerButton || null}
        >
          {modalStack[modalStack.length - 1].content}
        </CustomModal>
      )}
    </ModalStackContext.Provider>
  );
};
